// Single source of truth for article authors. The byline on every guide
// (GuideLayout) and the public profile page (/auteur/<slug>) both read from
// here, so a name or role change only happens in one place.

export interface Author {
  slug: string;
  /** Display name shown in the byline and on the profile page. */
  name: string;
  /** Role at Biedradar, shown under the name and in Person JSON-LD jobTitle. */
  role: string;
  /** Deliberately short bio — one line, plain language. */
  bio: string;
}

/** Every article currently carries this byline unless overridden. */
export const DEFAULT_AUTHOR_SLUG = "marijn-alfred";

export const AUTHORS: Record<string, Author> = {
  "marijn-alfred": {
    slug: "marijn-alfred",
    name: "Marijn Alfred",
    role: "CMO van Biedradar",
    bio: "Gewone gast uit Nederland.",
  },
};

/** Canonical path for an author's profile page. */
export function authorPath(author: Pick<Author, "slug">): string {
  return `/auteur/${author.slug}`;
}

/** Two-letter initials for the square avatar (e.g. "Marijn Alfred" → "MA"). */
export function authorInitials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}
